import type { SxProps, Theme } from '@mui/material';
export const styles: Record<string, SxProps<Theme>> = {
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'space-between',
    gap: '5px',
    cursor: 'pointer'
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexGrow: '1'
  },
  header: {
    marginBottom: '10px'
  },
  avatar: {
    flexShrink: 0,
    marginLeft: 'auto'
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '180px',
    width: '180px'
  }
};